import { createSlice, isPending, isRejected, isFulfilled } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
    name: 'loading',
    initialState: {
        isLoading: false,
        pendingRequests: 0,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(isPending, (state) => {
                state.pendingRequests += 1;
                state.isLoading = true;
            })
            .addMatcher(
                (action) => isFulfilled(action) || isRejected(action),
                (state) => {
                    state.pendingRequests -= 1;
                    state.isLoading = state.pendingRequests > 0;
                }
            );
    },
});

export default loadingSlice.reducer;